import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Text card — Morning Brief, generic AI narratives.
 */
export default function TextCardWidget({ data }) {
    const { t } = useTranslation();
    if (!data?.data) return null;
    const d = data.data;
    const text = d.text || d.insight?.text || d.narrative || t('No content.');
    return (
        <div className="v3-ai-glow" style={{ padding: '10px 18px 14px' }}>
            <div className="v3-body" style={{ whiteSpace: 'pre-wrap', fontSize: 13, lineHeight: 1.6 }}>
                {text}
            </div>
        </div>
    );
}
